import { DEFAULT_TILE, worldToScreen, type IsoTileSize } from './iso.js';

import type Phaser from 'phaser';

/**
 * Genera un tilemap iso 16×16 procedural con tres tonos placeholder
 * (paleta visual-direction.md: petróleo / pizarra / hueso).
 *
 * Sin atlas: dibujamos rhombus con Graphics. Suficiente para spike 2.
 */

const PETROLEO = 0x1c2a33;
const PIZARRA = 0x2a3540;
const HUESO = 0xf4ecd8;

export interface IsoTilemapOptions {
  size?: number;
  tile?: IsoTileSize;
  /** Centro en píxeles donde renderizar. */
  originScreen?: { x: number; y: number };
}

export function drawIsoTilemap(
  scene: Phaser.Scene,
  options: IsoTilemapOptions = {},
): Phaser.GameObjects.Container {
  const size = options.size ?? 16;
  const tile = options.tile ?? DEFAULT_TILE;
  const origin = options.originScreen ?? { x: scene.scale.width / 2, y: scene.scale.height / 3 };

  const container = scene.add.container(origin.x, origin.y);
  const g = scene.add.graphics({ x: 0, y: 0 });
  container.add(g);

  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      const screen = worldToScreen({ x, y }, tile);
      // Tile rhombus: cuatro vértices.
      const cx = screen.x;
      const cy = screen.y;
      const hw = tile.width / 2;
      const hh = tile.height / 2;
      const checker = (x + y) % 2 === 0 ? PETROLEO : PIZARRA;
      g.fillStyle(checker, 1);
      g.beginPath();
      g.moveTo(cx, cy - hh);
      g.lineTo(cx + hw, cy);
      g.lineTo(cx, cy + hh);
      g.lineTo(cx - hw, cy);
      g.closePath();
      g.fillPath();
      // Borde hueso muy tenue.
      g.lineStyle(1, HUESO, 0.08);
      g.strokePath();
    }
  }
  return container;
}
